import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import BookingForm from "./bookingForm";
import Slider from "react-slick";
import LocationAndRating from "./locationAndRating";

export default function HeroComponentV4({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 1100px)" });
  const btnList = content.services && content.services.length > 0 ? content.services : [];
  const [selectedService, setSelectedService] = useState({ button: content.services[0], class: "videoConsult" });
  const [submittedMobile, setSubmittedMobile] = useState(false);
  const [bookedMobile, setBookedMobile] = useState(false);

  const settings = {
    infinite: false,
    draggable: true,
    arrows: false,
    dots: false,
    variableWidth: true,
    cssEase: "cubic-bezier(0.165, 0.840, 0.440, 1.000)"
  };

  function handleSelectedService(btn) {
    setSelectedService(
      btn.package.trim() === "Video Consult"
        ? { button: btn, class: "videoConsult" }
        : btn.package.trim() === "Doctor Visit"
        ? { button: btn, class: "doctorVisit" }
        : btn.package.trim() === "Nurse Visit"
        ? { button: btn, class: "nurseVisit" }
        : btn.package.trim() === "Ambulance"
        ? { button: btn, class: "ambulance" }
        : ""
    );
  }
  return (
    <div id="heroV4">
      {!isMobile && (
        <div className="heroRight">
          <img alt="" src={content.image.desktop.url} />
        </div>
      )}
      <div className="heroLeft">
        <div className="heroTexts">
          <div className="title">{content.title}</div>
          <div className="description">{content.description}</div>
          {isMobile && (
            <div className="heroRight">
              <img alt="" src={content.image.desktop.url} />
            </div>
          )}
          {!isMobile ? (
            <div className="btnList">
              {btnList &&
                btnList.length > 0 &&
                btnList.map((btn, index) => (
                  <div
                    className={`button ${
                      btn.package.trim() === selectedService.button.package ? selectedService.class : ""
                    }`}
                    key={index}
                    onClick={() => handleSelectedService(btn)}>
                    <div className="">{btn.package.trim()}</div>
                  </div>
                ))}
            </div>
          ) : (
            !submittedMobile && (
              <div className="btnListMobile">
                <Slider {...settings}>
                  {btnList.map((btn, index) => (
                    <div
                      className={`button ${
                        btn.package.trim() === selectedService.button.package ? selectedService.class : ""
                      }`}
                      key={index}
                      onClick={() => handleSelectedService(btn)}>
                      <div className="">{btn.package.trim()}</div>
                    </div>
                  ))}
                </Slider>
              </div>
            )
          )}
        </div>
        <BookingForm
          service={selectedService.button}
          isMobile={isMobile}
          submittedMobile={submittedMobile}
          setSubmittedMobile={setSubmittedMobile}
          bookedMobile={bookedMobile}
          setBookedMobile={setBookedMobile}
          bufferTime={content.bufferTimeForBooking}
          formUrl={content.formUrl}
        />
        <div
          className={`heroBottom${
            bookedMobile && !submittedMobile
              ? " bookedMobile"
              : bookedMobile && setBookedMobile
              ? " submittedMobile"
              : ""
          }`}>
          {!bookedMobile && !submittedMobile && <LocationAndRating content={content} />}
        </div>
      </div>
    </div>
  );
}
